module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2meoD"))).then(() => parcelRequire('8rm4T'));